import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const opts = {
  icons: {
    iconfont: "md"
  },
  theme: {
    dark: false,
    themes: {
      light: {
        next: "#ec406f",
        darkNext: "#c13660",
        tesfriRaspberry: "#ec406f",
        anchor: "#ec406f"
      }
    }
  }
};

export default new Vuetify(opts);
